export const images25 = [
        { anchor: require("../images/2025/icicc-25-1.JPG") },
        { anchor: require("../images/2025/icicc-25-2.JPG") },
        { anchor: require("../images/2025/icicc-25-3.JPG") },
        { anchor: require("../images/2025/icicc-25-4.JPG") },
        { anchor: require("../images/2025/icicc-25-5.JPG") },
        { anchor: require("../images/2025/icicc-25-6.JPG") },
        { anchor: require("../images/2025/icicc-25-7.JPG") },
        { anchor: require("../images/2025/icicc-25-8.JPG") },
        { anchor: require("../images/2025/icicc-25-9.JPG") },
        { anchor: require("../images/2025/icicc-25-10.JPG") },
        { anchor: require("../images/2025/icicc-25-11.JPG") },
        { anchor: require("../images/2025/icicc-25-12.JPG") },
        { anchor: require("../images/2025/icicc-25-13.JPG") },
        { anchor: require("../images/2025/icicc-25-14.JPG") },
        { anchor: require("../images/2025/icicc-25-15.JPG") },
        { anchor: require("../images/2025/icicc-25-16.JPG") },
        { anchor: require("../images/2025/icicc-25-17.JPG") },
        { anchor: require("../images/2025/icicc-25-18.JPG") },
        { anchor: require("../images/2025/icicc-25-19.JPG") },
        { anchor: require("../images/2025/icicc-25-20.JPG") },
        { anchor: require("../images/2025/icicc-25-21.JPG") },
        { anchor: require("../images/2025/icicc-25-22.JPG") },
        { anchor: require("../images/2025/icicc-25-23.JPG") },
        { anchor: require("../images/2025/icicc-25-24.JPG") },
        { anchor: require("../images/2025/icicc-25-25.JPG") },
        { anchor: require("../images/2025/icicc-25-26.JPG") },
        { anchor: require("../images/2025/icicc-25-27.JPG") },
        { anchor: require("../images/2025/icicc-25-28.JPG") },
        { anchor: require("../images/2025/icicc-25-29.JPG") },
        { anchor: require("../images/2025/icicc-25-30.JPG") },
        { anchor: require("../images/2025/icicc-25-31.JPG") },
        { anchor: require("../images/2025/icicc-25-32.JPG") },
        { anchor: require("../images/2025/icicc-25-33.JPG") },
        { anchor: require("../images/2025/icicc-25-34.JPG") },
        { anchor: require("../images/2025/icicc-25-35.JPG") },
        { anchor: require("../images/2025/icicc-25-36.JPG") },        
];
export const images21 = [
    {
        anchor: require("../images/2021/icicc-21-1.jpeg")
    },{
        anchor: require("../images/2021/icicc-21-2.jpeg")
    },{
        anchor: require("../images/2021/icicc-21-3.jpeg")
    },{
        anchor: require("../images/2021/icicc-21-4.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-5.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-6.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-7.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-8.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-9.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-10.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-11.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-12.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-13.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-14.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-15.jpeg")
    }, 
];

export const images20 = [
    {
        anchor: require("../images/2020/ic20-1.jpeg")
    },{
        anchor: require("../images/2020/ic20-2.jpeg")
    },{
        anchor: require("../images/2020/ic20-3.jpeg")
    },{
        anchor: require("../images/2020/ic20-4.jpeg")
    }, {
        anchor: require("../images/2020/ic20-5.jpeg")
    }, {
        anchor: require("../images/2020/ic20-6.jpeg")
    }, {
        anchor: require("../images/2020/ic20-7.jpeg")
    }, {
        anchor: require("../images/2020/ic20-8.jpeg")
    }, {
        anchor: require("../images/2020/ic20-9.jpeg")
    }, 
];

export const images19 = [
    {
        anchor: require("../images/2019/1.jpeg")
    },{
        anchor: require("../images/2019/2.jpeg")
    },{
        anchor: require("../images/2019/3.jpeg")
    },{
        anchor: require("../images/2019/4.jpeg")
    }, {
        anchor: require("../images/2019/5.jpeg")
    }, {
        anchor: require("../images/2019/6.jpeg")
    }, {
        anchor: require("../images/2019/7.jpeg")
    }, {
        anchor: require("../images/2019/8.jpeg")
    }, {
        anchor: require("../images/2019/9.jpeg")
    }, {
        anchor: require("../images/2019/10.jpeg")
    }, {
        anchor: require("../images/2019/11.jpeg")
    }, {
        anchor: require("../images/2019/12.jpeg")
    }, {
        anchor: require("../images/2019/13.jpeg")
    }, {
        anchor: require("../images/2019/14.jpeg")
    }, {
        anchor: require("../images/2019/15.jpeg")
    }, {
        anchor: require("../images/2019/16.jpeg")
    },  {
        anchor: require("../images/2019/17.jpeg")
    },  {
        anchor: require("../images/2019/18.jpeg")
    },  {
        anchor: require("../images/2019/19.jpeg")
    },  {
        anchor: require("../images/2019/20.jpeg")
    },  {
        anchor: require("../images/2019/21.jpeg")
    },   {
        anchor: require("../images/2019/22.jpeg")
    }, 
];

export const images18 = [
    {
        anchor: require("../images/2018/ic18-1.png")
    },{
        anchor: require("../images/2018/ic18-2.png")
    },{
        anchor: require("../images/2018/ic18-3.png")
    },{
        anchor: require("../images/2018/ic18-4.png")
    }, {
        anchor: require("../images/2018/ic18-5.png")
    },  
];